<template>
  <Navigation withExit @back="emit('back')" @exit="emit('exit')" />
  <Title>
    {{ i18n(translations.title) }}
    <template #subtitle>
      {{ subtitle }}
    </template>
  </Title>

  <MessageForm
    :isLoading
    :mostUrgentTask
    @submit="(values) => emit('submit', values)"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'

import MessageForm from '../../../../MessageForm/MessageForm.vue'
import Navigation from '../../../../Navigation/Navigation.vue'
import Title from '../../../../Title/Title.vue'

import translations from './ExplainProblem.translations'

defineProps<{
  isLoading: boolean
  mostUrgentTask?: OrderlineOpenTask
  subtitle: string
}>()

const emit = defineEmits(['back', 'exit', 'submit'])

const i18n = useI18n()
</script>
